module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-latin-ext121.b57f4d0.woff2";